import React from 'react';
import { useOutsideClick } from '../Hooks/useOutsideClick';
import { translate } from '../Services/translation';
import MiniCartProduct from './MiniCartProduct';
import { Portal } from 'react-portal';

const MiniCart = ({ bottomOfNavbar, quantity, orderRows, includeVAT, orderTotal, checkoutUrl, showInfo, toggle, update }) => {
    const miniCartRef = React.useRef()
    const miniCartInfoRef = React.useRef()
    
    // TODO FIX! Does not work :)))
    useOutsideClick(miniCartInfoRef, showInfo && toggle)
    

    const getMiniCartRightPos = () => {
        if(!miniCartRef || !miniCartRef.current) return 0
        var boundingRect = miniCartRef.current.getBoundingClientRect()
        return window.innerWidth - boundingRect.x - (boundingRect.width*2)
    }

    return <div className="cart cart--mini" ref={miniCartRef}>
        <div onClick={() => toggle()}>
            <i className="icon icon-shopping-bag">
                <span className="cart__quantity">{ quantity }</span>
            </i>
        </div>
        {showInfo && <Portal node={document && document.body}>
            <div className={ `cart__info ${!showInfo ? 'cart__info--hidden' : ''}` } style={{top: bottomOfNavbar, right: getMiniCartRightPos() }} ref={miniCartInfoRef}>
            {orderRows.length > 0
                ? <div className="mini-cart-wrap">
                    <div className="cart__header">
                        <div className="icon icon-cross cart__close" onClick={toggle}></div>
                        <div className="cart__header-text" >{translate('checkout.cart.title')}</div>
                    </div>
                    <div className="mini-cart-wrap__scroll">
                        {orderRows.map(orderRow => {
                            const { rowSystemId, quantity, size } = orderRow;
                            return (
                                <MiniCartProduct
                                    key={rowSystemId}
                                    product={orderRow}
                                    onCartItemIncrement={() => update(rowSystemId, quantity + 1)}
                                    onCartItemDecrement={() => update(rowSystemId, quantity - 1)}
                                    onCartItemRemove={() => update(rowSystemId, 0)}
                                />
                            );
                        })}
                    </div>
                    <div className="mini-cart-wrap__fixed">
                        <div className="cart__summary">
                            <div className="cart__summary__info-row">
                                <div className="cart__split-row">
                                    <span className="cart__split-row-totalText">{includeVAT ? translate('minicart.taxesincluded') : translate('minicart.total')}</span>
                                    <span className="cart__split-row__total">{orderTotal}</span>
                                </div>
                            </div>
                        </div>
                        <a href={checkoutUrl} className="cart__checkout-button btn btn--secondary btn--small">{translate('minicart.checkout')}</a>
                    </div>
                </div>
                : <div className="cart__header">
                    <div className="icon icon-cross cart__close" onClick={toggle}></div>
                    <div className="cart__header-text" >
                        {translate('checkout.cart.empty')}
                    </div>
                </div>
            }
            </div>
        </Portal>}
    </div>
}

export default MiniCart;